import AdminUserList from "./AdminUserList";
import AdminUserEdit from "./AdminUserEdit";
import AdminUserCreate from "./AdminUserCreate";

const adminUsers = {
  list: AdminUserList,
  edit: AdminUserEdit,
  create: AdminUserCreate,
};

export default adminUsers;
